import {useEffect} from "react";

export const useCleanupOnUnload = (cleanup) => {
  useEffect(() => {
    window.addEventListener("beforeunload", cleanup);
    return () => {
      cleanup();
      window.removeEventListener("beforeunload", cleanup);
    };
  }, [cleanup]);
};
